import _ from 'lodash';

const { gsap } = require('gsap');
const { ScrollTrigger } = require("gsap/ScrollTrigger");

const ScrollEvents = function () {

    
    const animeTextIntro = (el) => {

        gsap.utils.toArray(".text-anim").forEach(el => {
            gsap.to(el, {
                //height: 0,
                ease: "power4.out",
                duration: 1,
                scrollTrigger: {
                    trigger: $(el).closest('.webdoor').length > 0 ? $(el).closest('.webdoor') : $(el).closest('section'),
                    start: "top center",
                    end: "center top",
                    scrub: 2,
                    toggleClass: 'motion-in',
                    // markers:true
                }
            });
        })

    }



    const parallaxWebdoor = function (el) {

        gsap.fromTo($(el).not(".no-plx").find('img, video'),
            {
                yPercent: 0,
                scale: 1,
            }, {
            yPercent: 35,
            scale: 1.2,
            ease: "none",
            scrollTrigger: {
                trigger: el,
                start: "top top",
                end: "bottom -=50%",
                scrub: true
            }
        });

    }

    const startCounters = () => {
        gsap.utils.toArray('.storage_numer').forEach(el => {
            gsap.from(el,
                {
                    innerText: 0,
                    duration: 5,
                    snap : {
                        innerText: 0.1
                    },
                    scrollTrigger: {
                        trigger: $(el).closest('.wrap-counters'),
                        start: "top bottom",
                        end: "bottom bottom",
                        scrub: 2,
                        // markers : true
                    }
                },
            );
        })
    }


    const elmToScroll = function (el) {
        let _this = el.attr('data-scrollto');
        setTimeout(() => {
            scrollToElm(_this, 0);
        }, 500);
    }

    const scrollToElm = function (target, _top) {

        if(!_top){
            _top = document.querySelector('header').clientHeight;
        }

        history.replaceState(null, null, ' ');

        gsap.to(window, 
            {
                duration: .5,
                scrollTo: (document.querySelector(target).offsetTop - _top),
                ease: "none",
            }
        );


    }

    const elmWebdoorScroll = (() => {

        const logoWebdoor = document.querySelector('.scroll-elm-webdoor');

        gsap.to(logoWebdoor, {
            yPercent: 35,
            scale: "+=0.5",
            autoAlpha: 0,
            ease: "none",
            scrollTrigger: {
                trigger: ".webdoor",
                start: "top top",
                end: "bottom +=100",
                scrub: true
            }
        });

    })

    const expImage = (() => {
        gsap.utils.toArray(".revealUp").forEach(el => {
            gsap.fromTo(el,
                {
                    scale: 1.4,
                    yPercent: 55
                }, {
                yPercent: 0,
                scale: 1,
                autoAlpha: 1,
                ease: "none",
                scrollTrigger: {
                    trigger: el,
                    start: "top bottom",
                    end: "center bottom",
                    scrub: 2
                }
            });
        })

    })


    const layerMaskAnimation = (() => {
        gsap.utils.toArray(".mask-layer-animation").forEach(el => {
            gsap.to(el, {
                //height: 0,
                ease: "power4.out",
                duration: 1,
                scrollTrigger: {
                    trigger: el,
                    start: "top center",
                    end: "center top",
                    scrub: 2,
                    toggleClass: 'motion-in'
                }
            });
        })

    })

    const footerAnimate = (() => {

        const elmFooter = document.querySelector("footer");
        gsap.from(elmFooter, {
            scrollTrigger: {
                start: 'top center',
                trigger: elmFooter,
                toggleClass: 'motion-in',
                // markers : true
            }
        });

    });

    return {

        animeTextIntro: animeTextIntro,


        init: function (el) {

            if(window.location.hash) {
                let _hash = "#section-"+window.location.hash.substring(1); //Puts hash in variable, and removes the # character
                console.log(_hash);

                if($(_hash).length <= 0) return;

                setTimeout(() => {
                    scrollToElm(_hash, 0);
                }, 500); 
              }

            // animeTextIntro(".text-anim");

            if ($(".webdoor-start").length > 0) {
                parallaxWebdoor(".webdoor-start");
            }
            
            if ($(".storage_numer").length > 0) {
                startCounters();
            }

            //logo home
            if (document.querySelector('.scroll-elm-webdoor')) {
                elmWebdoorScroll();
            }

            if (document.querySelector('.mask-layer-animation')) {
                layerMaskAnimation();
            }


            expImage();
            // footerAnimate();


            $(document).on('click', '[data-scrollto]', function () {
                elmToScroll($(this));
            });

            //quando ajax carregado forca ir topo da pagina
            if (el) {
                scrollToElm(el);
            }

        }
    }

}();

export default ScrollEvents;